import styled from 'styled-components';

export const OptionLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CheckMark = styled.span`
  font-size: 16px;
  color: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  flex-shrink: 0;
`;

/** Count of the selected skills the trigger has no room to name. */
export const OverflowCount = styled.span`
  flex-shrink: 0;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
`;
